import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import Api from "../../utils/api";
export function getTransactions(_x) {
  return _getTransactions.apply(this, arguments);
}
function _getTransactions() {
  _getTransactions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var state,
      commit,
      fresh,
      _yield$Api$get,
      data,
      _args = arguments;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          state = _ref.state, commit = _ref.commit;
          fresh = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
          if (!(state.transactions && !fresh)) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return", state.transactions);
        case 1:
          _context.next = 2;
          return Api().get('api/transactions');
        case 2:
          _yield$Api$get = _context.sent;
          data = _yield$Api$get.data;
          commit('transactions/setTransactions', data, {
            root: true
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getTransactions.apply(this, arguments);
}